import { blue } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { DatagridConfigurableWithStickyActions } from 'shared/react-admin/Datagrids';
import { withDatagridStickyStyles } from 'shared/react-admin/Datagrids/DatagridSticky/withDatagridStickyStyles';
import { ChipField, TextField } from 'shared/react-admin/Fields';
import { getColumnStyle } from 'utils';

const shrinkColumnStyle = { width: 0 };
const columnStyle120 = getColumnStyle(120);

const StickyDatagridConfigurableWithStickyActions = withDatagridStickyStyles(
  DatagridConfigurableWithStickyActions,
);

export const DatagridStyled = styled(StickyDatagridConfigurableWithStickyActions)({
  '& .column-active': { textAlign: 'center', ...getColumnStyle(68) },
  '& .column-provider': shrinkColumnStyle,
  '& .column-credentials': getColumnStyle(159),
  '& .column-merchantCredentials': shrinkColumnStyle,
  '& .column-currency': shrinkColumnStyle,
  '& .column-merchantIdEnabled': getColumnStyle(115),
  '& .column-gateways': shrinkColumnStyle,
  '& .column-createdAt': columnStyle120,
  '& .column-updatedAt': columnStyle120,
});

export const ChipFieldLinkStyled = styled(ChipField)(({ theme }) => ({
  '& .MuiChip-label': {
    color: theme.palette.primary.main,
  },
}));

export const TextFieldStyled = styled(TextField)({
  cursor: 'pointer',
  color: blue[700],
  textDecoration: 'underline',
});
